const calcEmployeeUtilizationRate = (employee) => {
  const totalPersonal =
    employee.callTypes.find((callType) => callType.callTypeName === "PERSONAL")
      ?.actualHours || 0;

  if (!employee.billableHours || employee.actualHours === totalPersonal) {
    return 0;
  }

  return parseFloat(
    (
      (employee.billableHours / (employee.actualHours - totalPersonal)) *
      100
    ).toFixed(2)
  );
};

const calcDepartmentUtilizationRate = (department, month) => {
  const totalPersonal = department.employees
    ?.flatMap((employee) => {
      const employeeMonth = employee.months.find(
        (m) => `${m.month}-${m.year}` === month
      );
      return parseFloat(
        employeeMonth?.callTypes
          .find((callType) => callType.callTypeName === "PERSONAL")
          ?.actualHours?.toFixed(2) || 0
      );
    })
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

  const totalBillable = department.employees
    ?.flatMap((employee) => {
      const employeeMonth = employee.months.find(
        (m) => `${m.month}-${m.year}` === month
      );
      return parseFloat(employeeMonth?.billableHours?.toFixed(2) || 0);
    })
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

  const totalActual = department.employees
    ?.flatMap((employee) => {
      const employeeMonth = employee.months.find(
        (m) => `${m.month}-${m.year}` === month
      );
      return parseFloat(employeeMonth?.actualHours?.toFixed(2) || 0);
    })
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

  if (!totalBillable || totalActual === totalPersonal) {
    return 0;
  }

  return parseFloat(
    ((totalBillable / (totalActual - totalPersonal)) * 100).toFixed(2)
  );
};

const getEmploymentStatusLabel = (employmentStatus) => {
  let label = "";
  switch (employmentStatus) {
    case "Consultant":
      label = " (C)";
      break;
    case "Intern":
      label = " (I)";
      break;
    case "Hourly":
      label = " (H)";
      break;
    default:
      break;
  }
  return label;
};

export {
  calcDepartmentUtilizationRate,
  calcEmployeeUtilizationRate,
  getEmploymentStatusLabel
};
